import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import { useToasts } from 'react-toast-notifications'
import userApi from '_api/user'
import { ConsolidatedContext } from '_context/ConsolidatedContext'

export default function useConsolidated() {
  const history = useHistory()
  const { addToast } = useToasts()
  const { removeConsolidated, refreshConsolidated } = useContext(ConsolidatedContext)

  const [editingId, setEditingId] = useState(null)
  const [editingName, setEditingName] = useState('')
  const [isUpdating, setIsUpdating] = useState(false)

  const handleDeleteConsolidated = async (id, e) => {
    if (e && e.preventDefault) e.preventDefault()
    const confirmed = window.confirm('Are you sure you want to delete this consolidated list?')
    if (!confirmed) return
    try {
      await userApi.deleteListConsolidated(id)
      if (history.location.pathname !== '/manage-orders') {
        history.push('/manage-orders')
      }
      removeConsolidated(id)
      addToast('Deleted consolidated list successfully.', { appearance: 'success', autoDismiss: true })
    } catch (error) {
      addToast('Delete failed.', { appearance: 'error', autoDismiss: true })
    }
  }

  const handleEditClick = (child) => {
    setEditingId(child.id)
    setEditingName(child.title)
  }

  const handleSaveEdit = async (consolidatedId) => {
    if (!editingName.trim()) {
      addToast('Name cannot be empty', { appearance: 'error', autoDismiss: true })
      return
    }

    setIsUpdating(true)
    try {
      await userApi.updateNameConsolidated(consolidatedId.id, editingName.trim())
      addToast('Name updated successfully.', { appearance: 'success', autoDismiss: true })
      setEditingId(null)
      setEditingName('')
    } catch (error) {
      addToast('Update failed.', { appearance: 'error', autoDismiss: true })
    } finally {
      setIsUpdating(false)
      refreshConsolidated()
    }
  }

  const handleCancelEdit = () => {
    setEditingId(null)
    setEditingName('')
  }

  return {
    editingId,
    editingName,
    setEditingName,
    isUpdating,
    handleDeleteConsolidated,
    handleEditClick,
    handleSaveEdit,
    handleCancelEdit,
  }
}
